import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=c0d994f0&scoped=true"
import script from "./user-info.vue?vue&type=script&lang=js"
export * from "./user-info.vue?vue&type=script&lang=js"
import style0 from "./user-info.vue?vue&type=style&index=0&id=c0d994f0&prod&lang=scss&scoped=true"
import style1 from "./user-info.vue?vue&type=style&index=1&id=c0d994f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d994f0",
  null
  
)

export default component.exports